import { get, getOr } from "lodash/fp";

export const getErrorCode = (error) =>
  getOr("default-message", "response.errors[0].extensions.code", error);

// Reads the user-facing `message` off a graphql-request error
// (`error.response.errors[0].message`). Returns `undefined` when absent so callers
// can fall back to a generic string. Used to surface BE-authored typed-error messages
// verbatim (e.g. R4-1 duplicate affiliate-product errors).
export const getErrorMessage = (error): string | undefined =>
  get("response.errors[0].message", error);
